import { Component, OnInit, Inject, inject, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Router, ActivatedRoute } from "@angular/router";
import { StandardService } from "../services/standard.service";
import { Standard } from "../models/standard";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import {
  StandardTypeEnum,
  StandardListType,
  UserRoleEnum,
  FilteringEnum,
} from "../core/constant";
import { CryptographyService } from "../services/cryptography.service";
import { LocationService } from "../services/location.service";
import { SelectedStandard } from "../models/selected-standard";
import { SelectedStandardDetail } from "../models/selected-standard-detail";
import { MatMenuTrigger } from "@angular/material/menu";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { DatePipe, Location } from "@angular/common";
import DOMPurify from "dompurify";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";

declare var $: any;

@Component({
  selector: "app-view-all-standard-details-view",
  templateUrl: "./view-all-standard-details-view.component.html",
  styleUrls: ["./view-all-standard-details-view.component.scss"],
  providers: [DatePipe],
})
export class ViewAllStandardDetailsViewComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);
  currentIndex = 0;
  cardsVisible = 4;
  allLocations: string = "";
  subLocations: string = "";
  keyContactEmail: string = "";
  createdOn: Date;
  detailsExpanded = false;
  additionalInfoExpanded = false;
  standardTypeName: string;
  loading: boolean = false;
  gapLoading: boolean = true;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<img src="/assets/images/back.svg">',
      '<img src="/assets/images/next.svg">',
    ],
    responsive: {
      0: { items: 1 },
      400: { items: 1 },
      740: { items: 1 },
      940: { items: 1 },
    },
    nav: true,
  };

  grsId: number = 0;
  notes: SafeHtml = "";
  additionalInformation: SafeHtml = "";
  grsDetail: SelectedStandardDetail = new SelectedStandardDetail();
  error: string = "";
  userRole: number = 2;

  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  getStandardTypeName(id: number): string {
    return StandardTypeEnum[id];
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }
  get isImpersonating(): boolean {
    return sessionStorage.getItem("impersonationView") === "true";
  }
  get countryId(): number {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (sessionCountryId) {
      try {
        return typeof sessionCountryId === "string"
          ? JSON.parse(sessionCountryId)
          : Number(sessionCountryId);
      } catch {
        return Number(sessionCountryId);
      }
    }
    const storageCountry = this.cryptographyService.decryptData(
      this.storage.get("countryId")
    );
    return Array.isArray(storageCountry)
      ? storageCountry[0]
      : Number(storageCountry);
  }
  get countryIds(): number[] {
    const cid = this.countryId;
    if (!cid) return [];
    return [Number(cid)];
  }

  get keyContactEmailResolved(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.email ||
      d?.keyContact?.Email ||
      d?.standard?.keyContact?.email ||
      d?.standard?.keyContact?.Email ||
      d?.standard?.email ||
      d?.standard?.Email ||
      d?.email ||
      d?.Email ||
      this.keyContactEmail ||
      ""
    );
  }

  get linksList(): any[] {
    const d = this.grsDetail as any;
    const rawLinks =
      d?.links ||
      d?.standard?.links ||
      d?.Links ||
      d?.standard?.Links ||
      d?.resourceLinks1 ||
      [];
    if (!Array.isArray(rawLinks)) return [];
    return rawLinks
      .map((l: any) => ({
        url: l?.url || l?.Url || "",
        title: l?.title || l?.Title || l?.url || l?.Url || "",
      }))
      .filter((l) => !!l.url?.trim() || !!l.title?.trim());
  }

  get hardwareDescription(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.emailDescription ||
      d?.keyContact?.EmailDescription ||
      d?.standard?.keyContact?.emailDescription ||
      d?.standard?.keyContact?.EmailDescription ||
      d?.standard?.emailDescription ||
      d?.standard?.EmailDescription ||
      d?.emailDescription ||
      d?.EmailDescription ||
      d?.keyContactDesc ||
      d?.standard?.keyContactDesc ||
      ""
    );
  }

  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  locationId: number = 0;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    public standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private ngbModal: NgbModal,
    private cryptographyService: CryptographyService,
    public locationService: LocationService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private location: Location
  ) {
    this.grsId = parseInt(this.activeRoute.snapshot.paramMap.get("grsId"));
    this.locationId = parseInt(
      this.activeRoute.snapshot.paramMap.get("locationId")
    );
  }

  ngOnInit() {
    this.userRole = sessionStorage.getItem("userRoleId")
      ? this.cryptographyService.decryptData(
          sessionStorage.getItem("userRoleId")
        )
      : this.cryptographyService.decryptData(this.storage.get("userRole"));

    this.getDetailByGrbesId(this.grsId);
  }

  getDetailByGrbesId(grsId: number) {
    this.loading = true;
    this.standardService
      .getGrbesDetailInfomationByStandardId(
        grsId,
        this.countryIds,
        this.standardService.minimumStandardFiltration.filterSet,
        StandardListType.AllStandards,
        this.standardService.minimumStandardFiltration.searchKey,
        this.getAppliedFilters()
      )
      .subscribe((data: SelectedStandardDetail) => {
        this.grsDetail = new SelectedStandardDetail(data);
        this.keyContactEmail = (this.grsDetail as any)?.keyContact?.email;

        if (
          this.grsDetail.standard?.standardLocation &&
          this.grsDetail.standard.standardLocation.length > 0
        ) {
          this.allLocations = this.grsDetail.standard.standardLocation
            .map((loc: any) => loc.locationType.name)
            .join(", ");
          this.subLocations = this.grsDetail.standard.standardLocation
            .map((loc: any) =>
              loc.locationType.subLocationTypes?.length
                ? loc.locationType.subLocationTypes
                    .map((sloc) => sloc.name)
                    .join(", ")
                : ""
            )
            .filter(Boolean)
            .join(", ");
        } else if (this.grsDetail.standard?.locationType?.name) {
          this.allLocations = this.grsDetail.standard.locationType.name;
          this.subLocations = "";
        } else {
          this.allLocations = "--";
          this.subLocations = "--";
        }

        const cleanNotes = DOMPurify.sanitize(
          this.grsDetail.standard?.note || ""
        );
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);

        const cleanAddInfo = DOMPurify.sanitize(
          this.grsDetail.standard?.additionalInformation || ""
        );
        this.additionalInformation =
          this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);

        this.loading = false;
        this.gapLoading = false;
      }, (error: any) => {
        this.error = error;
        this.loading = false;
      });
  }

  getAppliedFilters() {
    let idx =
      this.standardService.minimumStandardFiltration.filterSet.findIndex(
        (i) => i.type == FilteringEnum.FilterByStandardType
      );
    if (idx == -1) return [];
    return this.standardService.minimumStandardFiltration.filterSet[idx].ids;
  }

  addToNrbes(standardId, standardTypeId) {
    this.loading = true;
    this.standardService
      .addStandardToNrbes(
        standardId,
        this.countryId,
        standardTypeId === 0 ? 6 : 3,
        this.cryptographyService.decryptData(this.storage.get("userId"))
      )
      .subscribe(() => {
        this.loading = false;
        this.getDetailByGrbesId(this.grsDetail.standard.id);
      });
  }

  downloadExcel() {
    this.standardService.downloadSingleStandardExcel(
      this.grsDetail,
      "building"
    );
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2 * 1000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }

  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }
  toggleDetails2() {
    this.additionalInfoExpanded = !this.additionalInfoExpanded;
  }

  copyText(content: any) {
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.grsDetail.standard?.note || ""
    );
  }
  getAdditionalInfo() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.grsDetail.standard?.additionalInformation || ""
    );
  }
  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(["/view-all-standards"]);
    }
  }

  get maxIndex(): number {
    return Math.max(
      0,
      (this.grsDetail.dependentStandards?.length || 0) - this.cardsVisible
    );
  }

  get canPrev(): boolean {
    return this.currentIndex > 0;
  }

  get canNext(): boolean {
    return this.currentIndex < this.maxIndex;
  }

  prev(): void {
    if (this.canPrev) {
      this.currentIndex--;
    }
  }

  next(): void {
    if (this.canNext) {
      this.currentIndex++;
    }
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  getTransformStyle(): string {
    const offset = this.currentIndex * (100 / this.cardsVisible + 0.75);
    return `translateX(calc(-${offset}%))`;
  }

  get isSameDescription(): boolean {
    const newDesc =
      this.grsDetail?.standard?.newRestaurantDescription?.trim();
    const existingDesc = this.grsDetail?.standard?.description?.trim();

    return !!newDesc && !!existingDesc && newDesc === existingDesc;
  }

  get hasNewDescription(): boolean {
    return !!this.grsDetail?.standard?.newRestaurantDescription;
  }

  get hasExistingDescription(): boolean {
    return !!this.grsDetail?.standard?.description;
  }
}
